import React, { useCallback, useEffect, useMemo } from 'react'

import getConfig from 'next/config'
import { connect } from 'redux-zero/react'

import { AppContextType } from '@embed/components/helpers'
import { ControlledPlayerNoSSR } from '@microsites/components/ControlledPlayer/ControlledPlayerNoSSR'
import VideoHead from '@microsites/components/VideoHead/VideoHead'
import { dispatch } from '@microsites/store'
import { historyPush } from '@microsites/utils/microsites/routing'

function DirectVideo({ params, ssrVideo, videoId }) {
  const appContext = useMemo(() => {
    const { oauthClientId, oauthClientEncodedId } =
      // TODO(CS-442): ESLint Fixes for New rules enabled on Zeffo
      // eslint-disable-next-line no-unsafe-optional-chaining
      getConfig()?.publicRuntimeConfig
    return {
      appContextType: AppContextType.VIDEO_DETAIL_CONTEXT_TYPE,
      oauthClientId,
      oauthClientEncodedId,
    }
  }, [])

  useEffect(() => {
    dispatch.setContext({ appContext })
  }, [appContext])

  const onNavigateToVideo = useCallback(({ video }) => {
    historyPush(`/watch?fw_video=${video.encoded_id}`)
  }, [])

  return (
    <>
      {videoId && (
        <ControlledPlayerNoSSR
          appContext={appContext}
          params={params}
          videos={[ssrVideo]}
          videoId={videoId}
          onNavigateToVideo={onNavigateToVideo}
        />
      )}
      {ssrVideo && <VideoHead video={ssrVideo} />}
    </>
  )
}

export default connect((state) => ({
  params: state.params,
}))(DirectVideo)
